import { render, staticRenderFns } from "./ReUploadDocs.vue?vue&type=template&id=1a841aa2&scoped=true"
import script from "./ReUploadDocs.vue?vue&type=script&lang=js"
export * from "./ReUploadDocs.vue?vue&type=script&lang=js"
import style0 from "./ReUploadDocs.vue?vue&type=style&index=0&id=1a841aa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a841aa2",
  null
  
)

export default component.exports